import { useMemo } from 'react'
import { useForm, Controller } from 'react-hook-form'
import * as Yup from 'yup'
import { useTranslation } from 'react-i18next'
import { yupResolver } from '@hookform/resolvers/yup'

export const initialValues = {
  email: '',
}

const usePasswordForgotForm = () => {
  const { t } = useTranslation()
  const validationSchema = useMemo(
    () =>
      Yup.object().shape({
        email: Yup.string()
          .max(
            50,
            t('ERROR.E000002', {
              field: t('SYSCOMMON.email'),
              character: 50,
            })
          )
          .email(t('ERROR.E000004'))
          .required(
            t('ERROR.E000001', {
              field: t('SYSCOMMON.email'),
            })
          ),
      }),
    []
  )

  const methods = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: initialValues,
    mode: 'onBlur',
  })

  return { Controller, methods, initialValues }
}

export default usePasswordForgotForm
